module.exports = __webpack_public_path__ + "static/media/insu.2615249b.png";